import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class DeviceService {
    async getPublicIP(): Promise<string> {
        try {
          const res = await fetch('https://api.ipify.org?format=json');
          const data = await res.json();
          return data.ip;
        } catch {
          return 'IP desconocida';
        }
      }
    
      getDeviceInfo(): string {
        const ua = navigator.userAgent;
        return ua;
      }
    
      async getLocation(): Promise<string> {
        return new Promise((resolve) => {
          if (!navigator.geolocation) {
            resolve('Ubicación no disponible');
          }
    
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              const { latitude, longitude } = pos.coords;
              resolve(`Lat: ${latitude}, Lng: ${longitude}`);
            },
            () => resolve('Permiso denegado o fallo')
          );
        });
      }

      getLocationLiteral(): Promise<google.maps.LatLngLiteral | null> {
        return new Promise((resolve) => {
          if (!navigator.geolocation) return resolve(null);
    
          navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              });
            },
            () => resolve(null),
            { enableHighAccuracy: true }
          );
        });
      }
    
}